export const NAV = {
  logo: "nav-logo",
  homeLink: "nav-link-home",
  gemeentenLink: "nav-link-gemeenten",
  deelnemersLink: "nav-link-deelnemers",
  programmaLink: "nav-link-programma",
  methodeLink: "nav-link-methode",
  overOnsLink: "nav-link-over-ons",
  faqLink: "nav-link-faq",
  contactLink: "nav-link-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const HOME = {
  ctaGemeenten: "home-cta-gemeenten",
  ctaDeelnemers: "home-cta-deelnemers",
  ctaPrimaryContact: "home-cta-primary-contact",
  pillarCard: "home-pillar-card",
  journeyFlow: "home-journey-flow",
};

export const GEMEENTEN = {
  downloadBrochure: "gem-download-brochure",
  downloadVigor: "gem-download-vigor",
  downloadFlyer: "gem-download-flyer",
  downloadQA: "gem-download-qa",
  downloadPilot: "gem-download-pilot",
  ctaKennismaking: "gem-cta-kennismaking",
  ctaPilot: "gem-cta-pilot",
};

export const DEELNEMERS = {
  ctaAanmelden: "deel-cta-aanmelden",
  ctaInfo: "deel-cta-info",
};

export const CONTACT = {
  formName: "contact-form-name",
  formEmail: "contact-form-email",
  formMessage: "contact-form-message",
  formRole: "contact-form-role",
  formSubmit: "contact-form-submit",
  cardGemeente: "contact-card-gemeente",
  cardDeelnemer: "contact-card-deelnemer",
  cardPartner: "contact-card-partner",
};

export const FAQ = {
  itemPrefix: "faq-item",
  categoryPrefix: "faq-category",
};
